import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "@headlessui/react";
import { CompanyDetails } from "./CompanyDetails/CompanyDetails";
import { Payments } from "./Payments/Payments";
import { Settings } from "./Settings/Settings";
import { Vat } from "./VAT/Vat";
import { CreateTax } from "./VAT/CreateTax";
import { SigninSecurity } from "./SigninSecurity/SigninSecurity";
import "./setting.css";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export const MainSettings = () => {
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [openCreateTax, setOpenCreateTax] = useState(false);
    const [taxId, setTaxId] = useState(""); 
    const { t } = useTranslation();     

    const tabs = [
        {
            name: `${t("Company Details")}`,
            component: <CompanyDetails />,
        },
        {
            name: `${t("Settings")}`,
            component: <Settings />,
        },
        {
            name: `${t("Payments")}`,
            component: <Payments />,
        },
        {
            name: `${t("VAT")}`,
            component: <Vat setOpenCreateTax={setOpenCreateTax} setTaxId={setTaxId}/>,
        },
        {
            name: `${t("Sign-in & Security")}`,
            component: <SigninSecurity />,
        },
    ];

    if (openCreateTax)
        return (
            <div className="w-11/12 px-2 sm:px-0 mx-auto">
                <CreateTax 
                    setOpenCreateTax={setOpenCreateTax} 
                    setSelectedIndex={setSelectedIndex} 
                    taxId={taxId}
                    setTaxId={setTaxId}
                    />
            </div>
        );

    return (
        <div className="w-3/4 px-2 sm:px-0 mt-7 mx-11">
            <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
                <Tab.List className="flex max-w-2xl rounded-lg shadow-md bg-gray-100">
                    {tabs.map(({ name }) => (
                        <Tab
                            key={name}
                            className={({ selected }) =>
                                classNames(
                                    "w-full first:rounded-l-2xl tabs p-2 leading-5 text-xs font-medium",
                                    "ring-white font-extrabold focus:outline-none",
                                    selected
                                        ? "bg-purple-500 f shadow-xl hover:text-white text-white"
                                        : "text-black-700 hover:bg-indigo-100"
                                )
                            }
                        >
                            {name}
                        </Tab>
                    ))}
                </Tab.List>
                <Tab.Panels className="mt-2 py-1 bg-white ">
                    {tabs.map((category, idx) => (
                        <Tab.Panel
                            key={idx}
                            className={classNames(
                                "bg-white focus:outline-none"
                            )}
                        >
                            {category.component}
                        </Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};
